import { DefaultService } from '@/services/DefaultService';

export default class AgendaAtividadeService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }
    
    find(uuid) {
        return this._http.get(`${this._env}/agro/scheduledactivity/${uuid}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    insertBulk(agendaatividade) {
        return this._http.post(`${this._env}/agro/scheduledactivity/insertbulk`, agendaatividade, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    save(agendaatividade) {
        return this._http.post(`${this._env}/agro/scheduledactivity`, agendaatividade, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    delete(uuid) {
        return this._http.delete(`${this._env}/agro/scheduledactivity/${uuid}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    execute(uuid) {
        return this._http.get(`${this._env}/agro/scheduledactivity/${uuid}/finish`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(filtros, column, order, page = 0, limit = 50, ...params) {
        return this._http.post(encodeURI(`${this._env}/agro/scheduledactivity.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), filtros, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(agendaatividade) {
        return this._http.post(`${this._env}/agro/scheduledactivity/updatesituacao`, agendaatividade, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

}